import { render, staticRenderFns } from "./ReturnText.vue?vue&type=template&id=a665e408&scoped=true&"
import script from "./ReturnText.vue?vue&type=script&lang=js&"
export * from "./ReturnText.vue?vue&type=script&lang=js&"
import style0 from "./ReturnText.vue?vue&type=style&index=0&id=a665e408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a665e408",
  null
  
)

export default component.exports